export default "__VITE_ASSET__UDs2fTrB__"